
import { locationOptions } from "../../../constants/srfConstants";
import {
  accuracyFormat,
  DateisValid,
  parseRange,
} from "../../../utils/components/accuracyandlcandrangesshow";

export let printCertificateSection = {
  firstpagelikeJRPM: false,
  lastpagelikeJRPM: false,
  dateofPerformancelikeJrpm: false,
  disciplineAndReadinTableStartNewpage: false,
  jrpmtable: false,
  readingTableSerialNoColumnShow: false,
};

export const headerConfig = {
  headerCALIBRATIONCERTIFICATE: true,
  headerCALIBRATIONCERTIFICATEgap: 10,
  headerCALIBRATIONCERTIFICATEwithoutgap: 7,
  lettterImgHeight: 100,
  headerTableHeight: 30,
  headerandbodygap: 10,
  tableRowfontSizes: 8.5,
  cellPadding: { top: 4, left: 5, bottom: 4, right: 5 },
};

export const calculateHeader = {
  headerCALIBRATIONCERTIFICATExpostion:
    headerConfig.headerCALIBRATIONCERTIFICATE
      ? headerConfig.lettterImgHeight +
        headerConfig.headerCALIBRATIONCERTIFICATEgap
      : headerConfig.lettterImgHeight +
        headerConfig.headerCALIBRATIONCERTIFICATEwithoutgap,
  headerCALIBRATIONCERTIFICATExpostionafter:
    headerConfig.lettterImgHeight +
    headerConfig.headerCALIBRATIONCERTIFICATEgap +
    15,
};

export const totalHeaderHeightWithCalibrationLableorNot = {
  total: headerConfig.headerCALIBRATIONCERTIFICATE
    ? headerConfig.lettterImgHeight + headerConfig.headerTableHeight + 25
    : headerConfig.lettterImgHeight + headerConfig.headerTableHeight + 7,
};

export const footerConfig = {
  electronicSign:true,
  footerCALIBRATIONCERTIFICATE: false,
  footerimgRemove:true,
  footerlinewidth: 0,
  footerimgHeight: 50,
  footertableHeight: 50,
  footerandbodygap: 57,
  endcertificateandimggap: 5,
  stampui: false,
};
let pageHeight = 841;
export const certificateBorderLayout = {
  x: 15,
  y: totalHeaderHeightWithCalibrationLableorNot.total - 5,
  width: 565,
  height:
    pageHeight -
    footerConfig.footerimgHeight -
    footerConfig.footertableHeight -
    footerConfig.footerandbodygap -
    totalHeaderHeightWithCalibrationLableorNot.total +
    6,
  // height: 570
};

export const tableConfiguration = {
  margins: { top: 0, right: 25, bottom: 0, left: 25 },
};

export const tableConfigurationheaderandfooter = {
  margins: { top: 0, right: 15, bottom: 0, left: 15 },
};

export const fontFamilyConfig = {
  useFont: "Aptos",
  bold: "bold",
  normal: "normal",
};

export const waterMarkImgConfig = {
  logoWidth: 250,
  logoHeight: 200,
};

export const environmentTableConfig = {
  spacebetweenHeadingandTable: 5,
  innerBorder: 0,
  cellPadding: { top: 2, left: 5, bottom: 2, right: 5 },
};

export const loadAndAddFont = async (
  pdfDoc,
  fontUrl,
  fontNameTTF,
  fontName,
  fontStyle
) => {
  const arrayBufferToBase64 = (buffer) => {
    let binary = "";
    const bytes = new Uint8Array(buffer);
    const chunkSize = 8192; // Process in chunks for large buffers
    for (let i = 0; i < bytes.length; i += chunkSize) {
      binary += String.fromCharCode(...bytes.subarray(i, i + chunkSize));
    }
    return btoa(binary);
  };

  const fontResponse = await fetch(fontUrl);
  const fontBuffer = await fontResponse.arrayBuffer();
  const fontBase64 = arrayBufferToBase64(fontBuffer);

  pdfDoc.addFileToVFS(`${fontNameTTF}.ttf`, fontBase64);
  pdfDoc.addFont(`${fontNameTTF}.ttf`, fontName, fontStyle);
};

export const customFontFamily = {
  bold: "bold",
  normal: "normal",
  boldFont: "AptosBold",
  normalFont: "AptosNormal",
};

export const digitallySignConfig = {
  digitallySignONorOFF: false,
  signatureTextContnet: (certificateDetails) => [
    `REVA PHOENIX LABS AND CONSULTANTS`,
    `PRIVATE LIMITED`,
    `Date: ${DateisValid(certificateDetails?.dateOfIssue || certificateDetails?.approvedDate)} ${new Date().toLocaleTimeString("en-GB", { timeZone: "Asia/Kolkata"})} +05:30`,
    `Reason: Calibration Certificate`,
    `Location: Chennai`,
  ],
};



export let certificateEndSection = [];

// Define a function to generate the textList array
export const certificateFirstSectionHeading = (
  disciplineName,
  certificateDetails
) => {
  return [
    { text: disciplineName || "", fontSize: 17 },
    { text: "Calibration Certificate", fontSize: 17 },
    { text: "For", fontSize: 17 },
    {
      text: certificateDetails?.requestedname
        ? certificateDetails?.requestedname
        : certificateDetails?.instrumentName || "",
      fontSize: 17,
    },
  ];
};

export let certificatefirstSection = [];

// Exporting MasterEQPDetails
export const MasterEQPDetails = (standards) => ({
  heading: "MASTER(S) USED FOR CALIBRATION",
  headingFontSize: 9,
  headingBottomSpace: 0,
  headingTopSpace: 0,
  headingAlign: "center",
  spacebetweenHeadingandTable: 5,
  cellPadding: { top: 3, left: 5, bottom: 3, right: 5 },
  tableTextfontSize: 8.5,
  tableValueAlign: "center",
  keys: [
    // "Sl. No.",
    "STANDARD DESCRIPTION",
    "SR.No./ID No.",
    "CERTIFICATE NO",
    "VALID UPTO",
    "CALIBRATION FROM",
  ],
  values: standards.map((item, index) => [
    // index + 1,
    item.standardName,
    item.stId && item.serialNo  ? `${item.stId} / ${item.serialNo}` : `${item.stId} ${item.serialNo}`,
    item.certificateNumber,
    DateisValid(item.validUpto),
    item.traceability,
    // `${item.certificateNumber} Valid till ${DateisValid(item.validUpto)}`,
  ]),
});

export const UUCDetails = (certificateDetails) => {
  const getExtraColumn = (key) => {
    const value = certificateDetails?.extraColumnsParse?.[key];
    return value ? { key, value } : null; // Only return key-value pair if there's a value
  };
  let ISendcalibrationDate  = certificateDetails?.endCalibrationDate ?  `${DateisValid(certificateDetails?.calibrationDate)} to ${DateisValid(certificateDetails?.endCalibrationDate)}` : DateisValid(certificateDetails?.calibrationDate);

  const standardFields = [
    {
      key: "UNIT UNDER CALIBRATION",
      value:
        certificateDetails?.requestedname || certificateDetails?.instrumentName,
    },
    {
      key: "CAL. PROCEDURE/STD.",
      value: `${certificateDetails?.calProcRefNo || certificateDetails?.calibrationProcedureNo} / ${certificateDetails?.isaStandard || certificateDetails?.referenceStandards}`,
    },
    // { key: "SRF No", value: certificateDetails?.certificatesserviceReqNumber },
    { key: "SL./ID.NO.", value: certificateDetails?.serialNumber && certificateDetails?.DUCID ? `${certificateDetails?.serialNumber} / ${certificateDetails?.DUCID}` : certificateDetails?.serialNumber || certificateDetails?.DUCID  },
    {
      key: "CAL. PERFORMED AT",
      value: locationOptions.find(opt => opt.id == certificateDetails?.location)?.label || "",
    },
    { key: "MAKE", value: certificateDetails?.make },
    { key: "RECEIPT DATE OF UUC", value: DateisValid(certificateDetails?.receiptDate) },
    { key: "MODEL", value: certificateDetails?.model },
    { key: "CALIBRATION DATE", value: ISendcalibrationDate },
    { key: "SIZE / RANGE", value: parseRange(certificateDetails?.ranges) },
    { key: "SUGG DUE DATE", value:  certificateDetails?.calFrequency == "Not Required"
      ? "-"
      : certificateDetails?.calFrequency == "Customer Defined" 
      ? "Customer Defined" 
      : DateisValid(certificateDetails?.nextDueDate),
     },
    {
      key: "LEAST COUNT",
      value: parseRange(certificateDetails?.lc),
    },
    { key: "CERTIFICATE ISSUE DATE", value: certificateDetails?.dateOfIssue
        ? DateisValid(certificateDetails?.dateOfIssue)
        : DateisValid(certificateDetails?.approvedDate),
       },
    { key: "LOCATION", value: certificateDetails?.locationOfInstrument },
    { key: "VISUAL INSPECTION", value: certificateDetails?.ConOfDuc },
    // {
    //   key: "Standard Reference",
    //   value: certificateDetails?.isaStandard
    //     ? certificateDetails?.isaStandard
    //     : certificateDetails?.referenceStandards,
    // },
    { key: "Sensor Type", value: certificateDetails?.sensorType },
  ];

  // Extra fields
  const extraFields = ["Material"];

  // Add extra fields only if they have a value
  const extraPanelFields = extraFields
    .map(getExtraColumn)
    .filter((item) => item !== null);
  // Filter standard fields to include only those with values
  const filteredStandardFields = standardFields.filter((field) => field.value);
  // Combine filtered standard fields with extra fields (no special ordering)
  const allFields = [...filteredStandardFields, ...extraPanelFields];
  // Create rows from the fields, pairing key-value pairs
  const rows = [];
  for (let i = 0; i < allFields.length; i += 2) {
    rows.push([allFields[i], allFields[i + 1] || null]); // Add extra field as null if there's no pair
  }

  return {
    heading: "DETAILS OF UNIT UNDER CALIBRATION (UUC)",
    headingFontSize: 9,
    headingBottomSpace: 0,
    headingTopSpace: 0,
    headingAlign: "center",
    spacebetweenHeadingandTable: 5,
    innerBorder: 0,
    cellPadding: { top: 2, left: 5, bottom: 2, right: 5 },
    tableTextfontSize: 8.5,
    middleColumn: true,
    rows,
  };
};

export const NameAndAddressDetails = (certificateDetails,clientInfo) => {
  let ISendcalibrationDate  = certificateDetails?.endCalibrationDate ?  `${DateisValid(certificateDetails?.calibrationDate)} to ${DateisValid(certificateDetails?.endCalibrationDate)}` : DateisValid(certificateDetails?.calibrationDate);

  return {
    leftPanel: {
      keys: ["Customer Name & Address"],
      values: [
        `${clientInfo?.clientName || ""}\n${
          clientInfo?.address || ""
        }`,
      ],
    },
    rightPanel: {
      keys: ["DISCIPLINE", "SERVICE REQUEST NO."],
      values: [
        `${certificateDetails?.name || ""}${certificateDetails?.subGroup ? ` ( Group : ${certificateDetails.subGroup.replace(/\n/g,' ').replace(/,\s*/g,', ').trim()} )` : ""}${certificateDetails?.instumentssubGroup ? `, ${certificateDetails.instumentssubGroup}` : ""}`,
        certificateDetails?.certificatesserviceReqNumber
      ],
    },
    cellPadding: { top: 3, left: 5, bottom: 3, right: 5 },
    tableTextfontSize: 8.5,
    firsttwocolumnrowSpan: true
  };
};

export const performanceClaibrationDetails = (certificateDetails) => ({
  leftPanel: {
    keys: ["Date of Performance of Calibration"],
    values: [DateisValid(certificateDetails?.calibrationDate)],
  },
  rightPanel: {
    keys: ["Date of Issue", "Recommended Due Date"],
    values: [
      certificateDetails?.dateOfIssue
        ? DateisValid(certificateDetails?.dateOfIssue)
        : DateisValid(certificateDetails?.approvedDate),
        certificateDetails?.calFrequency == "Not Required" ? "-" : certificateDetails?.calFrequency == "Customer Defined" ? "Customer Defined" : certificateDetails?.calFrequency == "NA" ? "NA" : DateisValid(certificateDetails?.nextDueDate),
    ],
  },
});

export const dynamicHeader = (certificateDetailsConfig, calType) => {
  const revisedCertificateNumber = certificateDetailsConfig?.certificateNumber + (certificateDetailsConfig?.revisionNumber > 0 ? `/AMD-${certificateDetailsConfig?.revisionNumber}` : "");
  const headerKeysAndValues = calType != 1
  ? [{ keys: "Certificate Number", values: revisedCertificateNumber }]
  : [
      { keys: "ULR Number", values: certificateDetailsConfig?.ULRNo?.replace("\n", "") },
      { keys: "Certificate Number", values: revisedCertificateNumber },
    ];

    
    const leftAndRightKeyvalue = headerKeysAndValues.filter((field) => field.values);
    const rows = [];
    for (let i = 0; i < leftAndRightKeyvalue.length; i += 2) {
      rows.push([leftAndRightKeyvalue[i], leftAndRightKeyvalue[i + 1] || null]);
    }

  return {
    mergeKeyValue:true,
    headerKeysAndValues,
    firstcolheadersecondcolvalue:false,
    firstrowHeaderscondValue:false,   
    rows
  };
};


